module.exports = __webpack_public_path__ + "img/cert-no.c26f2d33.png";